// theme/index.js
import { createTheme } from '@mui/material/styles';

const modalPaper = {
  backgroundColor: 'background.paper',
  borderColor: 'contrastBorder',
  borderWidth: 4,
  borderRadius: 2,
  borderStyle: 'double',
  padding: 2,
  minWidth: 300,
  boxShadow: 24
};

const baseTheme = {

  customStyles: {
    modalPaper
  },

  components: {

  MuiCssBaseline: {
    styleOverrides: {

      body: {
        overflow: 'hidden',
        margin: 0,
        padding: 0,
      },

      '.custom-marker': {
        background: 'transparent !important',
        border: 'none !important'
      },

      // pontos operacionais
      '.map-point-label': {
        position: 'absolute',
        left: '50%',
        top: '100%',
        transform: 'translateX(-50%)',
        marginTop: 3,

        padding: '2px 5px',
        borderRadius: 4,

        backgroundColor: 'rgba(255, 255, 255, 0.9)',

        fontWeight: 700,
        whiteSpace: 'nowrap',
        color: '#333',

        lineHeight: 1.2,

        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.2)'
    },

      '.leaflet-container': {
        width: '100%',
        height: '100%'
      },

      // popup customizado
      '.point-status-popup .leaflet-popup-content-wrapper': {
        background: 'var(--popup-bg) !important',
      },
      '.point-status-popup .leaflet-popup-content': {
        color: 'var(--popup-color) !important',
        background: 'var(--popup-bg) !important',
      },

      '.point-status-popup .leaflet-popup-tip': {
        background: 'var(--popup-bg) !important'
      },

      '.point-status-popup .leaflet-popup-close-button': {
          color: 'var(--popup-color) !important'
        },

        '.pezinho-vehicle-popup .leaflet-popup-content': {
        margin: '7px 9px',
        lineHeight: 1.2
      },

      '.pezinho-vehicle-popup .leaflet-popup-content-wrapper': {
        borderRadius: 8
      },

      '.pezinho-vehicle-popup .leaflet-popup-close-button': {
        width: 20,
        height: 20,
        fontSize: 16,
        lineHeight: '20px'
      }
    }
  },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: '.8em',
          padding: '.8em',
          borderRadius: 8,
        },
      },
    },
    Header: {
      styleOverrides: {
        root: {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          padding: '0 20px',
          paddingTop: '6px',
          justifyContent: 'flex-end',
          boxSizing: 'border-box',
          // overflow: 'hidden',
          flexWrap: 'wrap'
        },
        userName: {
          flex: 1,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }
        
      }
    }
  },
};

const themes = {
  light: createTheme({
    ...baseTheme,
    palette: {
      mode: 'light',
      primary: { main: '#1976d2' },
      dark: { main: '#000000', contrastText: '#ffffff' },
      background: {
        default: '#fff',
        paper: '#f5f5f5',
        backdrop: 'rgba(245, 245, 245, .8)',
        custonSelect: '#f5f5f5'
      },
      inferred: {
        main: '#7e57c2',
        contrastText: '#ffffff'
      },
      contrastBorder: 'rgba(0, 0, 0, .6)'
    },
    components: {
      ...baseTheme.components,
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            ...baseTheme.components.MuiTooltip.styleOverrides.tooltip,
            backgroundColor: '#333',
            color: '#fff',
          },
        },
      },
    },
  }),
  dark: createTheme({
    ...baseTheme,
    palette: {
      mode: 'dark',
      primary: { main: '#90caf9' },
      dark: { main: '#e9e9e9', contrastText: '#000' },
      background: {
        default: '#121212',
        paper: '#1e1e1e',
        backdrop: 'rgba(30, 30, 30, .8)',
        custonSelect: '#383838'
      },
      inferred: {
        main: '#b39ddb',
        contrastText: '#000000'
      },
      contrastBorder: 'rgba(255, 255, 255, .6)'
    },
    components: {
      ...baseTheme.components,
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            ...baseTheme.components.MuiTooltip.styleOverrides.tooltip,
            backgroundColor: '#fff',
            color: '#000',
          },
        },
      },
    },
  }),
};

export default themes;
